import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MailIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
// This data would ideally come from a CMS or API
const teamMembersData = {
  'alfred-chuang': {
    name: 'Alfred Chuang',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053668/Alfred_Race_tvayqz.png',
    bio: `Alfred Chuang is a General Partner at Race Capital, bringing decades of experience as a technology entrepreneur and executive.

As the founder and CEO of BEA Systems, Alfred led the company from its inception to its acquisition by Oracle for $8.5 billion.

Prior to Race Capital, Alfred founded and served as CEO of Magnet Systems, a platform for building and deploying enterprise mobile applications. His deep expertise in enterprise software and infrastructure has made him a trusted advisor to numerous founders building the next generation of technology companies. Alfred's technical background and operational experience give him unique insights into the challenges that founders face when scaling their businesses.

He is passionate about helping entrepreneurs navigate these challenges and build category-defining companies.`,
    social: {
      email: 'alfred@race.capital',
      linkedin: 'https://www.linkedin.com/in/alchuang/',
      twitter: 'https://twitter.com/chuang_alfred?lang=en-GB'
    }
  },
  'bernard-chan': {
    name: 'Bernard Chan',
    title: 'Principal',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781046649/Bernard_Headshot_New_ak29dv.png',
    bio: `Bernard Chan is a Principal at Race Capital where he focuses on enterprise software, AI and data infrastructure investment opportunities.

Previously, Bernard was the CTO and Co-founder of a Y-Combinator backed fintech startup tackling cross-border payments and commerce.

Bernard holds a B.Eng and MEng in Materials Science and Engineering from Imperial College London where he had a focus on computational modeling of drug delivery carriers.`,
    social: {
      email: 'bernard@race.capital',
      linkedin: 'https://www.linkedin.com/in/bernard-chan-cl/',
      twitter: 'https://twitter.com/bernardchancl'
    }
  },
  'chris-mccann': {
    name: 'Chris McCann',
    title: 'General Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781047033/Chris_Headshot_New_-_Clear_wmmeid.png',
    bio: `Chris McCann is a General Partner at Race Capital, entrepreneur, and community builder.

Prior, Chris founded and led the community program at Greylock Partners, a San Francisco based venture capital firm with $3.5 billion under management which led investments in Facebook, LinkedIn, Figma, Dropbox, and Coinbase, among others.

Before he joined the firm, he was the co-founder and CEO of StartupDigest – one of the earliest technology focused email newsletters – which he grew from zero to over one million subscribers before being acquired by Techstars.

He was an early advisor for the Thiel Fellowship & StartX at Stanford University. He also writes a newsletter covering the VC and technology sectors which reaches 25,000 entrepreneurs, engineers, and investors on a weekly basis.`,
    social: {
      email: 'chris@race.capital',
      linkedin: 'https://www.linkedin.com/in/mccannatron/',
      twitter: 'https://twitter.com/mccannatron'
    }
  },
  'edith-yeung': {
    name: 'Edith Yeung',
    title: 'Venture Partner',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053661/Edith_Race_sik95j.png',
    bio: `Edith Yeung is a Venture Partner at Race Capital.

Edith is the seed investor in Solana (has been dubbed one of the best venture investments of all time), Lightning Network, Agora.io, Placer.ai, RapidAPI, and 60 other amazing startups.

Prior to Race Capital, Edith was a partner at 500 Startups, the world's most active early-stage fund and incubator which invested in Twilio, Credit Karma, Grab, and 2000 more companies.

Before 500, Edith was the general manager at Dolphin Browser, a Sequoia Capital - backed mobile browser with over 150 million installs worldwide. Edith also worked with many Fortune 500 companies such as Siebel, AMS, AT&T Wireless, and Autodesk.

She frequently speaks on venture capital, women in leadership, China and Silicon Valley technology and investment landscape. She is also a frequent guest lecturer at Berkeley and Stanford and commentator on BBC, CNBC, Wall Street Journal, Bloomberg, SCMP, Techcrunch, The Information, etc.`,
    social: {
      email: 'edith@race.capital',
      linkedin: 'https://www.linkedin.com/in/edithyeung/',
      twitter: 'https://twitter.com/edithyeung'
    }
  },
  'kelly-cheng': {
    name: 'Kelly Cheng',
    title: 'Partner, CFO',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781056952/ChatGPT_Image_Jun_10_2026_at_03_02_24_AM_wrcvwy.png',
    bio: `Kelly Cheng is a Partner and Chief Financial Officer at Race. She is an experienced financial executive who has built, scaled, and managed institutional finance and operations functions at leading investment firms for over two decades.

At Race Capital, Kelly manages and is responsible for all non-investment activities, including internal operations, finance and compliance.

Kelly previously served in leadership positions at Sequoia Heritage, HQ Capital, Hall Capital Partners and Standard Crypto. She began her career at Ernst & Young, LLP and PricewaterhouseCoopers, LLP.

Kelly graduated from the University of Massachusetts, Amherst, cum laude, with a BA in Accounting. Kelly serves on the Board of Trustees of Sacred Heart Schools, Atherton, and is a member of its Finance Committee.`,
    social: {
      email: 'kelly@race.capital',
      linkedin: 'http://www.linkedin.com/in/kbcheng',
      twitter: ''
    }
  },
  'matt-mclaughlin': {
    name: 'Matt McLaughlin',
    title: 'Senior Operating Partner, Capital Formation',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781056265/ChatGPT_Image_Jun_10_2026_at_02_50_39_AM_regtpp.png',
    bio: `Matt McLaughlin is a Senior Operating Partner at Race. Matt's primary role is to cultivate enduring and trustworthy relationships with portfolio companies, aiming to assist them in achieving their long-term growth and revenue targets. He provides strategic direction, practical insights, and specialized expertise in various areas such as sales, enterprise revenue scaling, hyper-growth strategies, revenue operations, as well as hiring and training.

Matt's Sales and Executive management career spans 25 years in the high-tech industry at companies like BEA Systems and Jobvite.

Matt built and managed B2B enterprise sales teams for established companies and start-ups in Cloud, AI, application software, and infrastructure. He possess a strong track record of delivering solutions resulting in significant revenue growth, across SMB, Mid-Market, and Enterprise Accounts.

Specialties: Software business executive, domestic and international sales management, extensive SaaS experience, revenue growth, sales infrastructure, methodology implementation, and large contract negotiation`,
    social: {
      email: 'matt@race.capital',
      linkedin: 'https://www.linkedin.com/in/mwmgtm/',
      twitter: ''
    }
  },
  'mohak-saxena': {
    name: 'Mohak Saxena',
    title: 'Investor',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1771635854/674ddd11189fcab109c08bf5_Screenshot_2024-12-02_at_4.15.10_PM_ydbxcz.png',
    bio: `Mohak Saxena is an Investor at Race Capital, focusing on early-stage companies in AI/ML, data infrastructure, and developer tools. With a unique blend of technical expertise and investment acumen, Mohak brings years of experience leading and advising innovative technology ventures.
    Before joining Race Capital, Mohak worked at Underscore VC, where he spearheaded the creation of an automated sourcing system for software startups. Previously, Mohak served as an engineering leader at DataRobot, managing high-impact AI projects, including COVID modeling and time series forecasting for the U.S. Department of Health and Human Services. His leadership scaled engineering teams and drove significant revenue growth through strategic contracts and innovative AI solutions.
    Mohak holds an MBA from NYU Stern School of Business, specializing in Finance, Financial Markets and Instruments, and Accounting, and a Bachelor's degree in Mathematics and Computer Science from the University of Michigan. He has also filed patents on cutting-edge AI techniques. Outside of work, Mohak is an avid golfer, tea enthusiast, and investor passionate about fostering transformative technologies.`,
    social: {
      email: 'mohak@race.capital',
      linkedin: 'https://www.linkedin.com/in/mohak-saxena',
      twitter: ''
    }
  },
  'alim-giga': {
    name: 'Alim Giga',
    title: 'Principal',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781047503/ChatGPT_Image_Jun_10_2026_at_12_24_51_AM_p6wm3a.png',
    bio: `Alim Giga is a Principal at Race Capital, specializing in early-stage investments in enterprise infrastructure and AI.

Prior to Race Capital, he was a Partner at Alumni Ventures, sourcing over 30 deals across AI, enterprise, and B2B SaaS. Alim's earlier experience includes roles at American Express Ventures and GE Ventures, where he focused on enterprise, fintech, and AI/ML investments.

Before moving into venture capital, he worked at Google managing a $100M book of business, and held product marketing and business development roles at PayPal and Instart Logic, a startup backed by a16z, Kleiner Perkins and Greylock Partners.

He holds a BS in Business and Accounting from the University of Southern California (magna cum laude), an MS in Management Science & Engineering from Stanford University, and an MBA from The Wharton School.`,
    social: {
      email: 'alim@race.capital',
      linkedin: 'https://www.linkedin.com/in/alimgiga/',
      twitter: ''
    }
  },
  'mariah-cole': {
    name: 'Mariah Cole',
    title: 'Executive Assistant, Office Manager',
    image: 'https://res.cloudinary.com/dtycj98cm/image/upload/c_fill,g_face,w_800,h_800/v1781053659/Mariah_Race_xe9yxn.png',
    bio: `Mariah Cole is an Executive Assistant and experienced Office Manager with a strong background in office administration, investor relations, and event planning. A graduate of San Jose State University, she built a solid foundation in organizational management and communication that supports her career today.

Throughout her professional experience, Mariah has demonstrated her talent for strengthening client relationships and identifying new opportunities. She also has a strong background in improvement strategy and focuses on streamlining processes, increasing team productivity, and improving daily operations.

Mariah takes pride in creating efficient workflows and building positive work environments. She brings a steady, solutions-focused approach to every challenge and is always looking for ways to elevate the overall workplace experience.`,
    social: {
      email: 'mariah@race.capital',
      linkedin: 'https://www.linkedin.com/in/mariah-cole-08310217a/',
      twitter: ''
    }
  }
};
export const TeamMemberPage = () => {
  const {
    slug
  } = useParams();
  const member = teamMembersData[slug];
  useEffect(() => {
    if (member) {
      document.title = `${member.name} | Race Capital`;
    } else {
      document.title = 'Team | Race Capital';
    }
  }, [member]);
  if (!member) {
    return <div className="w-full py-32 px-6 md:px-12 bg-white text-center mt-20" data-id="element-440" data-mp="b050ycq82pg0">
        <div className="max-w-7xl mx-auto" data-id="element-441" data-mp="5zhe83910url">
          <h1 className="text-5xl md:text-6xl font-bold text-[#070707] leading-tight mb-8 tracking-tight" data-id="element-442" data-mp="3sgzl28q1jj2q">
            Team Member Not Found
          </h1>
          <Link to="/team" className="text-red-600 hover:text-red-700 font-medium inline-flex items-center" data-id="element-443" data-mp="1bq2310gs52m">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-444" data-mp="3nhd53ritvoq8">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-445" data-mp="k163dqjz41k3" />
            </svg>
            Return to Team Page
          </Link>
        </div>
      </div>;
  }
  return <div className="w-full bg-white mt-20" data-id="element-446" data-mp="y05tl2n4woid">
      {/* Hero Section */}
      <section className="w-full py-24 px-6 md:px-12 bg-gradient-to-b from-white to-gray-50/50" data-id="element-447" data-mp="xyuo8ye1j8p5">
        <div className="max-w-7xl mx-auto" data-id="element-448" data-mp="12t8qnkr4eg3b">
          <div className="flex flex-col md:flex-row items-start gap-16" data-id="element-449" data-mp="2ngrk8zbgccz4">
            <div className="w-full md:w-1/3" data-id="element-450" data-mp="2iizrk32zgmtv">
              <div className="relative aspect-square overflow-hidden rounded-2xl bg-gray-100 shadow-xl" data-id="element-451" data-mp="2ii6u5spwz9oe">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" data-id="element-452" data-mp="2x6unrtg799bp" />
              </div>
              {/* Social Links */}
              <div className="flex items-center space-x-4 mt-8" data-id="element-453" data-mp="24ks0ucwjihr5">
                <a href={`mailto:${member.social.email}`} aria-label="Email" className="text-red-600 hover:text-red-700 transition-colors p-3 hover:bg-red-50 rounded-lg" data-id="element-454" data-mp="1zlf32x44rq9s">
                  <MailIcon size={24} data-id="element-455" data-mp="3pw9xmfw4ow61" />
                </a>
                {member.social.linkedin && <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-red-600 hover:text-red-700 transition-colors p-3 hover:bg-red-50 rounded-lg" data-id="element-456" data-mp="3kxgunhegwnk4">
                    <LinkedinIcon size={24} data-id="element-457" data-mp="23fq9flcdshbj" />
                  </a>}
                {member.social.twitter && <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-red-600 hover:text-red-700 transition-colors p-3 hover:bg-red-50 rounded-lg" data-id="element-458" data-mp="28h5x7l5y11xm">
                    <TwitterIcon size={24} data-id="element-459" data-mp="2r6chhcmdy1lj" />
                  </a>}
              </div>
            </div>
            <div className="w-full md:w-2/3" data-id="element-460" data-mp="2w5yupm27rhuc">
              <div className="flex items-center mb-8" data-id="element-461" data-mp="2w79yvmzkmrlz">
                <Link to="/team" className="text-red-600 hover:text-red-700 font-medium flex items-center transition-colors" data-id="element-462" data-mp="3140e683jxj6c">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-463" data-mp="369dozh11wu26">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-464" data-mp="2xaa365ai20jz" />
                  </svg>
                  Back to Team
                </Link>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-[#070707] leading-tight mb-4 tracking-tight" data-id="element-465" data-mp="3k7274h3qhn3j">
                {member.name}
              </h1>
              <p className="text-2xl text-red-600 font-semibold mb-10" data-id="element-466" data-mp="gl3ivu32pyx6">
                {member.title}
              </p>
              <div className="prose max-w-none" data-id="element-467" data-mp="brsahoim5a35">
                {member.bio.split('\n\n').map((paragraph, index) => <p key={index} className="text-gray-600 mb-6 text-lg leading-relaxed" data-id="element-468" data-mp="263a43gdph6bs" data-mpi={index}>
                    {paragraph}
                  </p>)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};